import styled from "styled-components"

export const ServiceContainer = styled.section`
height: auto;
margin-bottom: 2rem;`

export const ServiceWrapper = styled.div`
max-width: 1100px;
margin: 0 auto;

@media screen and (max-width: 768px){
    max-width: 320px;
}
`

export const ServiceContent = styled.div`
display: grid;
grid-template-columns: 1fr 1fr;
gap: 25px;

@media screen and (max-width: 768px){
    grid-template-columns: 1fr;
}
`

export const ServiceHead = styled.h1`
max-width: 400px;
line-height: 1.5;
margin-bottom: 1rem;
text-align: start;

@media screen and (max-width: 768px){
    margin-top: 2rem;
}
`

export const ServiceP = styled.p`
color: #333;
line-height: 1.8;
text-align: justify;
font-size: 18px;
display: grid;
align-self: center;
`

export const ServiceImage = styled.div`

`

export const Image = styled.img`
width: 90%;
`

